import axios from "axios";

// 🚀 Conectando o Front-end (na HostGator) com a API Python (no Render)
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://sistema-empresa-tntr.onrender.com",
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && token.length > 20 && token !== "null" && token !== "undefined") {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

// Mantemos apenas UM interceptor de resposta limpo
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;